import { api } from "@/lib/api";

const dataIt = (iso) => (iso && iso.length >= 10 ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "data sconosciuta");

// Controllo anti-duplicato: stesso numero documento + stesso fornitore/cliente. Ritorna true se si può procedere.
export async function confermaSeDuplicato({ numero, fornitore_id, cliente_id, escludi_id }) {
  if (!numero?.trim() || !(fornitore_id || cliente_id)) return true;
  try {
    const { data } = await api.get("/documenti/verifica", { params: { numero: numero.trim(), fornitore_id: fornitore_id || "", cliente_id: cliente_id || "", escludi_id: escludi_id || "" } });
    if (!data?.esiste) return true;
    return window.confirm(`Attenzione: questo documento è già stato registrato il ${dataIt(data.data)}${data.tipo ? ` (${data.tipo})` : ""}.\n\nVuoi procedere comunque con il salvataggio?`);
  } catch {
    return true;
  }
}
